import styled, { css } from 'styled-components';
export default styled.div.withConfig({
  displayName: "MTOBadgestyles",
  componentId: "sc-153pe2h-0"
})(["", ""], function (props) {
  return css(["text-align:center;letter-spacing:normal;display:inline-flex;justify-content:center;align-items:center;line-height:normal;padding:6px 8px 6px 8px;font-size:1.2rem;font-weight:", ";color:", ";background-color:", ";"], props.theme.font.weight.bold, props.theme.color.monochrome.white, props.theme.color.palette['blue-70']);
});